export default __webpack_public_path__ + "static/photoGalleryModule_cloud_top-b5a06c14d1c845f379331fad8ffd039b.webp";